module.exports = __webpack_public_path__ + "img/logo.c08d3178.png";